<!-- One box, one job: the page's viewport. Everything about it is explained in page-container.component.scss
     and docs/articles/frontend/page-layout-contract.md. -->
<div class="page-viewport">
  <ng-content></ng-content>
</div>
